




































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { CMS } from "@/common/state/cms/cms.api";
import { ModalConfig } from "@/components/root/modal";
import { ref, computed, onMounted, Ref } from "@vue/composition-api";
import Processing from "@/components/table/Processing.vue";
import { UseLoading } from "@/common/composition/loading";
import { CmsWalkthrough } from "@/common/state/cms/cms.models";
import { delayBy } from "@/fp";
import { UseMediaHero } from "@/components/root/media-hero/media-hero.state";
import { CopyUrl } from "@/common/clipboard";
export default Vue.extend({
  props: ["modalData"],
  components: {
    Modal,
    Processing,
  },
  setup(props) {
    const config = computed(() => {
      return {
        blank: true,
        blur: true,
        title: "",
        desc: "",
        width: "85rem",
        // @ts-ignore
        height: props.modalData.height || "70rem",
        // @ts-ignore
        backdropDismiss: props.modalData.use_as_mask ? false : true,
        // @ts-ignore
        withTopRightCloseBtn: props.modalData.use_as_mask ? false : true,
      } as ModalConfig;
    });

    const walkthrough_data = ref<CmsWalkthrough | null>(null);

    const [is_loading, set_loading] = UseLoading(false).as_arr();

    const show_full_img = (gif_url: string, element: HTMLElement) => {
      UseMediaHero.show({
        type: "img",
        url: gif_url,
        element,
      });
    };

    onMounted(async () => {
      set_loading(true);
      // @ts-ignore
      const item_id = props.modalData.id as string;
      await delayBy(1000);
      const res = await CMS.get_walkthrough({ id: item_id });
      if (res.success) {
        walkthrough_data.value = res.value[0];
      }
      set_loading(false);
    });

    return { config, is_loading, walkthrough_data, show_full_img, CopyUrl };
  },
});
